<template>
  <div>
    <div>
      <img
        class="backImg"
        :src="
          language === 'zh'
            ? require('@/assets/images/contactUs/backgroundImg.jpg')
            : require('@/assets/images/contactUs/en_backgroundImg.jpg')
        "
      />
    </div>
    <div class="bread">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="21" :md="20" :lg="18" :xl="16">
          <slot name="breadcrumb"></slot>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="21" :md="20" :lg="18" :xl="16">
          <div class="contentBox">
            <div class="leftBox">
              <div class="menuTitle">
                <span>{{ $t("route.Contact") }}</span>
              </div>
              <div
                :class="activeIndex == index ? 'activemenu' : 'menu'"
                v-for="(item, index) in contactList"
                :key="index"
                @click="menuClick(item.path, index, item.name)"
              >
                <div :class="activeIndex == index ? 'sign' : ''"></div>
                <div class="menu-title">{{ item.title }}</div>
                <!-- <div class="menu-to">
                  <i class="el-icon-arrow-right" style=" font-size: 14px;"></i>				
                </div> -->
              </div>
            </div>
            <div class="rightBox">
              <div class="boxTitle">{{ contactList[activeIndex].title }}</div>
              <div class="content">
                <router-view />
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="consult">
      <div class="contact">
        <img src="@/assets/images/contactUs/contact.png" alt="" />
        <div>{{ $t("contactUs.contactInfo.consultation") }}</div>
        <div class="contact_left">
          <img :src="temp.customer_service_wx_pic" alt="" />
          <template v-if="language === 'zh'">
            <div>扫一扫</div>
            <div>公众号客服</div>
          </template>
        </div>
      </div>
      <div class="feedback">
        <img src="@/assets/images/contactUs/feedback.png" alt="" />
        <div>{{ $t("contactUs.contactInfo.feedback") }}</div>
        <div class="feedback_left">
          <img :src="temp.feedback_pic" alt="" />
          <template v-if="language === 'zh'">
            <div>扫一扫</div>
            <div>意见反馈</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixins } from "@/mixins/list";
import { localStorage } from "@/utils/storage.js";
export default {
  mixins: [mixins],
  data() {
    return {
      language: localStorage.get("language") || "zh",
      activeIndex: 0,
      temp: this.$store.getters.baseParameter,
    };
  },
  watch: {
    $route: {
      handler(newValue, oldValue) {
        this.contactList.forEach((Element, index) => {
          if (Element.path == this.$route.fullPath) {
            this.activeIndex = index;
          }
        });
      },
      immediate: true,
    },
  },
  computed: {
    language() {
      return localStorage.get("language");
    },
  },
  methods: {
    menuClick(path, index, name) {
      if (name === "南航集团") {
        window.open(path, "_blank");
      } else {
        this.activeIndex = index;
        this.$router.push(path);
      }
    },
  },
};
</script>

<style scoped>
.backImg {
  width: 100%;
  /* height: 300px; */
}
.bread {
  background-color: #f6f6f6;
  padding: 15px 20px;
}
.container {
  padding: 40px 20px;
}
.contentBox {
  display: flex;
}
.leftBox {
  width: 20%;
  margin-right: 20px;
}
.menuTitle {
  padding: 10px;
  background-color: #32589f;
  /* text-align: center; */
  font-weight: 700;
  font-size: 18px;
}
.menuTitle > span {
  color: #fff;
  margin-left: 13px;
}
.activemenu {
  padding: 15px 10px;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  /* border: 1px solid #dcdfe6; */
  border-top: 0px;
  cursor: pointer;
}
.activemenu > div {
  color: #32589f;
  font-weight: 800;
}
.menu {
  padding: 15px 10px;
  display: flex;
  /* justify-content: space-between; */
  /* border: 1px solid #dcdfe6; */
  border-top: 0px;
  cursor: pointer;
  background-color: rgba(245, 245, 245, 1);
}
.menu > div {
  color: #333;
}
.menu:hover {
  background-color: #ecf8ff;
}
.menu:hover > div {
  color: #32589f;
  font-weight: 800;
}
.menu-title {
  margin-left: 8px;
}
.menu .menu-title {
  margin-left: 13px;
}
.rightBox {
  padding: 5px;
  width: 100%;
  overflow: hidden;
}
.boxTitle {
  font-size: 22px;
  font-weight: 800;
  padding-bottom: 10px;
  color: #015a9c;
  border-bottom: 1px solid #dcdfe6;
  letter-spacing: 2px;
}
.sign {
  width: 5px;
  height: 17px;
  background-color: #32589f;
  border-radius: 20px;
}
.content {
  margin-top: 20px;
}
/* 在线客服、意见反馈 */
.consult {
  position: fixed;
  right: 25px;
  bottom: 30px;
  padding: 10px;
  font-size: 10px;
  border-radius: 10px;
  background-color: #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.35);
}
.consult .contact img,
.consult .feedback img {
  width: 28px;
  height: 28px;
  margin: auto;
  margin-bottom: 5px;
}
.consult .contact {
  margin-bottom: 10px;
}
.consult > div {
  color: #666666;
  text-align: center;
  cursor: pointer;
}
.consult .contact_left,
.feedback .feedback_left {
  visibility: hidden;
  right: 80px;
  bottom: 30px;
  padding: 10px;
  position: absolute;
  border-radius: 10px;
  background-color: #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.35);
}
.feedback .feedback_left {
  bottom: 0;
}
.feedback .feedback_left img,
.consult .contact_left img {
  width: 100px;
  height: 100px;
}
.feedback:hover .feedback_left,
.contact:hover .contact_left {
  visibility: initial;
}
/*  */
@media only screen and (max-width: 768px) {
  .backImg {
    width: 100%;
    height: auto;
  }
  .contentBox {
    display: block;
  }
  .leftBox {
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }
  .rightBox {
    /* padding: 10px 0; */
    width: 100%;
  }
  .boxTitle {
    font-size: 17px;
    letter-spacing: 0px;
  }
}
</style>

